import { createAction } from '@reduxjs/toolkit';

import { AttendanceSession } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import {
  CreateAccountabilityTemplateRequest,
  GenerateAccountabilityTemplateSessionRequest,
  UpdateAccountabilityTemplateRequest,
  ViewAccountabilityTemplateRequest
} from './accountability-template.types';

export const requestCreateAccountabilityTemplate = createAction<
  SagaPayload<CreateAccountabilityTemplateRequest>['payload']
>('request/createAccountabilityTemplate');

export const requestViewAccountabilityTemplate = createAction<
  SagaPayload<ViewAccountabilityTemplateRequest>['payload']
>('request/viewAccountabilityTemplate');

export const requestUpdateAccountabilityTemplate = createAction<
  SagaPayload<UpdateAccountabilityTemplateRequest>['payload']
>('request/updateAccountabilityTemplate');

export const requestGenerateAccountabilityTemplateSessions = createAction<
  SagaPayload<GenerateAccountabilityTemplateSessionRequest, AttendanceSession[]>['payload']
>('request/generateAccountabilityTemplateSessions');
